import { QUOTATION_INSURANCE_CARRIER_STATE } from '@shared/constants/quotationInsuranceCarrierStates';

const isPackageQuotationStateLoading = (packageQuotationState) =>
  packageQuotationState === QUOTATION_INSURANCE_CARRIER_STATE.PENDING
  || packageQuotationState === QUOTATION_INSURANCE_CARRIER_STATE.STARTED;

/**
 * La cotización sigue en curso si hay algún package en pending/started
 * o alguna aseguradora esperada sin package aún en Redux.
 */
export const computeQuotationPetitionAlive = (state) => {
  const packages = state.globalQuotation?.quotation?.packages ?? [];
  const responses = state.comparationQuotation?.insuranceCarriersResponses ?? {};

  if (packages.some((insurancePackage) => isPackageQuotationStateLoading(insurancePackage.state))) {
    return true;
  }

  return Object.entries(responses).some(([insuranceCarrierId, insuranceCarrierResponse]) => {
    const hasPackageForInsuranceCarrier = packages.some(
      (insurancePackage) => String(insurancePackage.insurance_carrier) === String(insuranceCarrierId),
    );
    if (hasPackageForInsuranceCarrier) return false;

    if (insuranceCarrierResponse?.packageQuotationState != null) {
      return isPackageQuotationStateLoading(insuranceCarrierResponse.packageQuotationState);
    }

    return (insuranceCarrierResponse?.percent_progress ?? 0) < 100;
  });
};
